var render, staticRenderFns
import script from "./DisputeDetails.vue?vue&type=script&lang=js"
export * from "./DisputeDetails.vue?vue&type=script&lang=js"
import style0 from "./DisputeDetails.vue?vue&type=style&index=0&id=16a42d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a42d74",
  null
  
)

export default component.exports